// const apiBaseUrl = "https://tpsalesforce.in:8444/api";
 const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
//  const api = process.env.REACT_APP_API_BASE_URL;

 const environment = process.env.REACT_APP_ENVIRONMENT;

 console.log("API " ,apiBaseUrl);
//  console.log("All environment variables:", process.env);
//  console.log("Environment:", environment);

export const loginUser = `${apiBaseUrl}/Login/login`;
export const userlog = `${apiBaseUrl}/WGDealer/PostUserDetails`;
export const CustomerDataApi= `${apiBaseUrl}/WGDealer/GetCustomer`;
export const SoPostApi = `${apiBaseUrl}/WGDealer/InsertSO`;
export const PostCartItemApi =`${apiBaseUrl}/WGDealer/insertCartItems?`;
export const getCartItemApi = `${apiBaseUrl}/WGDealer/getCartItem?`;
export const removeItemInTable = `${apiBaseUrl}/WGDealer/RemoveItemFromTable?`;
export const getItemGroup = `${apiBaseUrl}/WGDealer/GetGroupItem?databaseName=`;
export const getItem = `${apiBaseUrl}/WGDealer/GetItemByGroup?groupCode=`;
export const getOutGoingPayment =`${apiBaseUrl}/OutGoingPayment/OutGoingPayment?dbName=`;
export const postOutGoingPayment = `${apiBaseUrl}/OutGoingPayment/OutGoingPaymentPost`;
export const getCompany = `${apiBaseUrl}/OutGoingPayment/getCompany?user=`;
export const getBranch = `${apiBaseUrl}/OutGoingPayment/GetBranch?dbName=`;
export const PostSalesQuotation = `${apiBaseUrl}/SalesQuotation`;
export const InsertSQOldOppr = `${apiBaseUrl}/SalesQuotation/InsertSQOldOppr`;
export const updateSQ=`${apiBaseUrl}/SalesQuotation/UpdateSalesQuotattion`
export const postQuationWithCustomer = `${apiBaseUrl}/SalesQuotation/customerAndQuotation`
export const postOrderWithCustomer = `${apiBaseUrl}/WGDealer/customerAndOrder`
export const GetPriceList = `${apiBaseUrl}/WGDealer/GetItemPriceList?ItemCode=`;
// export const GetSalesPerson =`${apiBaseUrl}/CustomerCreation/GetSalesPersons?`;
export const PostCustomerData =`${apiBaseUrl}/MasterData/PostCustomerData?companyName=`;
export const AccountData = `${apiBaseUrl}/MasterData/accountData?userid=`;
export const getLocation = "https://api-bdc.net/data/reverse-geocode?latitude=";
export const PostAttendance = `${apiBaseUrl}/Attendance/attendance`;
export const updateAttendance = `${apiBaseUrl}/Attendance/updateAttendance`;
export const getAttendanceByUser = `${apiBaseUrl}/Attendance/GetByUserAndDate/`;
export const getCrmData = `${apiBaseUrl}/CRM/CRMData?dbname=`;
export const postCrmData = `${apiBaseUrl}/CRM/CrmPost?companyName=`;
export const getItembySearch = `${apiBaseUrl}/WGDealer/GetItemBySearch?searchText=`;
export const getItembySearchWithTotal = `${apiBaseUrl}/WGDealer/GetItemBySearchWithTotal?searchText=`
export const PostCustomerAndOpp = `${apiBaseUrl}/CustomerCreation/CustomerAndOpportunity`;
export const SapConnection = `${apiBaseUrl}/WGDealer/SapConnection?CompanyName=`;
export const SapDisconnection = `${apiBaseUrl}/WGDealer/DisconnectSap?CompanyName=`;
export const CustomerFollowUp = `${apiBaseUrl}/CrmOpportunity/GetCrmOpportunity`;
export const GetOpportunityByID = `${apiBaseUrl}/CrmOpportunity/GetCrmOpporStage?DatabaseName=`;
export const PostCrmStage = `${apiBaseUrl}/CrmOpportunity/PostCrmStage`;
export const RefreshToken = `${apiBaseUrl}/WGDealer/refresh-token?refreshToken=`;
export const opprDocument = `${apiBaseUrl}/CRM/opprDocument?dbname=`;
export const GetDocTypeItem = `${apiBaseUrl}/CRM/GetDocTypeItem?DatabaseName=`;
// sales quatation history 
export const GetSqHistory = `${apiBaseUrl}/SQHistory/GetSQHistory?DatabaseName=`;
export const GetSQItems = `${apiBaseUrl}/SQHistory/GetItemBySQ?DatabaseName=`;

export const GetCRMForSQ = `${apiBaseUrl}/CrmOpportunity/GetCRMDataSQ?DatabaseName=`;

//Opportunity Summary LostOppor that reason
export const  GetReasonLostOppr=`${apiBaseUrl}/CrmOpportunity/GetOpprSummaryDescript?DatabaseName=`
export const  postCrmStatus=`${apiBaseUrl}/CrmOpportunity/postCrmStatus`

//Greeter
// export const GetGuestCode=`${apiBaseUrl}/WGDealer/GetGuestCode?SlpCode=`
export const UpdateGreeterStatus=`${apiBaseUrl}/WGDealer/UpdateGreeterStatus`


